import 'jquery';
import './slick/slick.js';

$(function() {

  $(document).on('click','[data-open-nav]', function() {
    $('.navigation').addClass('navigation--open');
  });

  $(document).on('click','[data-close-nav]', function() {
    $('.navigation').removeClass('navigation--open');
  });

  window.setTimeout(function(){
    $('.banner__scroll').addClass('banner__scroll--start');
  }, 1000);

  ///////////// Scroll to nav /////////////////////
  var scroll_to_links = document.querySelectorAll('[data-scroll-to]');

  for (var k = 0; k < scroll_to_links.length; k++) {
    var scroll_to_link = scroll_to_links[k];

    scroll_to_link.addEventListener('click', function(event) {
      if('scrollBehavior' in document.documentElement.style) {
        event.preventDefault();

        var anchor = this.getAttribute('href');
        var anchor_elem =  document.querySelector(anchor);

        scroll_to(anchor_elem);
      }
      
    });
  }

  function scroll_to(element) {
    var scroll_value = element.offsetTop;
    
    window.scrollTo({
      top: scroll_value,
      left: 0,
      behavior: 'smooth',
    });
  }

  $('.navigation__subnav').slideUp(300);

  $(document).on('click','[data-toggle-subnav]', function() {
  
    var was_open = $(this).hasClass('navigation__toggle navigation__toggle--expanded');

    var is_subsub = $(this).parent().hasClass('navigation__subnav-wrap');

    if(!is_subsub) {
      $('.navigation__toggle--expanded').removeClass('navigation__toggle--expanded');
      $('.navigation__subnav--expanded').slideUp(300);
      $('.navigation__subnav--expanded').removeClass('navigation__subnav--expanded');
  
      if(!was_open) {
        $(this).addClass('navigation__toggle--expanded');
        $(this).parents('.navigation__item').find('.navigation__subnav:first').addClass('navigation__subnav--expanded');
        $(this).parents('.navigation__item').find('.navigation__subnav:first').slideDown(300);
      }
    } else {
  
      if(!was_open) {
        $(this).addClass('navigation__toggle--expanded');
        $(this).parents('.navigation__subnav-item:first').find('.navigation__subnav').addClass('navigation__subnav--expanded');
        $(this).parents('.navigation__subnav-item:first').find('.navigation__subnav').slideDown(300);
      } else {
        $(this).removeClass('navigation__toggle--expanded');
        $(this).parents('.navigation__subnav-item:first').find('.navigation__subnav--expanded').slideUp(300);
        $(this).parents('.navigation__subnav-item:first').find('.navigation__subnav--expanded').removeClass('navigation__subnav--expanded');
      }
    }

  });


  /////////////////////////////////// Lazy Loadig images /////////////////////////////////////////
  //Handling lazyload
  const targets = document.querySelectorAll('[data-lazy-srcset], [data-lazy-src]');

  //lazy loading currently deactivated because it was messing up anchor links
  if ('IntersectionObserver' in window) {
    var map_obs_config = {
      // If the element gets within 400px in the Y axis, start the animation.
      rootMargin: '400px 0px 400px 0px',
      threshold: 0.01,
    };

    let lazyload_observer = new IntersectionObserver(function on_intersection(entries){
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          const img = entry.target;
          const src = img.getAttribute('data-lazy-src');

          if(null != src) {
            img.setAttribute('src', src);
          }

          const srcset = img.getAttribute('data-lazy-srcset');
          if(null != srcset) {
            img.setAttribute('srcset', srcset);
          }

          lazyload_observer.unobserve(img);
        }
      });
    }, map_obs_config);

    targets.forEach(function(target) {
      lazyload_observer.observe(target);
    });
  } else {

    for (var i = 0; i < targets.length; i++) {
      var target = targets[i];
      const src = target.getAttribute('data-lazy-src');

      if(null != src) {
        target.setAttribute('src', src);
      }
    
      const srcset = target.getAttribute('data-lazy-srcset');
      if(null != srcset) {
        target.setAttribute('srcset', srcset);
      }
    }
  }


  $('.wpcf7-select').change(function() {
    var selected = $(this).val();

    if (selected !== '') {
      $( this ).addClass('form__select--touched');
    }
  });


  load_slider();

  function load_slider() {

    var slider_html = '<div class="slider">';
      $('.wysiwyg .blocks-gallery-item figure a').each(function(){
        slider_html += '<div class="slider__slide">';
          //slider_html += '<img src="' + $(this).attr('href') + '" class="modal__img">';
          slider_html += '<img src="' + $(this).attr('href') + '">';
        slider_html += '</div>';
      })
    slider_html += '</div>';

    $('.modal__wrap').html(slider_html);

    $('.slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      variableWidth: true,
      adaptiveHeight: false,
      arrows: true,
      mobileFirst: true,
    });
  }

  $(document).on('click','.wysiwyg .blocks-gallery-item figure', function(e) {
    e.preventDefault();

    var target_index = $(this).parent().index();
    $('.slider').slick('slickGoTo', target_index, true);
    open_modal();
  });

  function open_modal(){
    $('.modal').addClass('modal--open')
  }

  $(document).on('click','[data-close-modal]', function() {
    close_momdal();
  });

  function close_momdal(){
    $('.modal').removeClass('modal--open')
  }

  
});


//35.865722, 139.850035

// eslint-disable-next-line no-unused-vars
var map, marker, map2, marker2;
var center = {
  lat: 35.865722,
  lng: 139.850035,
};

// eslint-disable-next-line no-unused-vars
function initMap() {
  var options = {
    center: center,
    zoom: 16,
    styles:[
      {
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#f6e2ca',
          },
        ],
      },
      {
        'elementType': 'labels.text.fill',
        'stylers': [
          {
            'color': '#523735',
          },
        ],
      },
      {
        'elementType': 'labels.text.stroke',
        'stylers': [
          {
            'color': '#f5f1e6',
          },
        ],
      },
      {
        'featureType': 'administrative',
        'elementType': 'geometry.stroke',
        'stylers': [
          {
            'color': '#c9b2a6',
          },
        ],
      },
      {
        'featureType': 'administrative.land_parcel',
        'elementType': 'geometry.stroke',
        'stylers': [
          {
            'color': '#dcd2be',
          },
        ],
      },
      {
        'featureType': 'administrative.land_parcel',
        'elementType': 'labels.text.fill',
        'stylers': [
          {
            'color': '#ae9e90',
          },
        ],
      },
      {
        'featureType': 'landscape.natural',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#f8eed5',
          },
        ],
      },
      {
        'featureType': 'poi',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#dfd2ae',
          },
        ],
      },
      {
        'featureType': 'poi',
        'elementType': 'labels.text.fill',
        'stylers': [
          {
            'color': '#93817c',
          },
        ],
      },
      {
        'featureType': 'poi.park',
        'elementType': 'geometry.fill',
        'stylers': [
          {
            'color': '#e1dfa7',
          },
        ],
      },
      {
        'featureType': 'poi.park',
        'elementType': 'labels.text.fill',
        'stylers': [
          {
            'color': '#447530',
          },
        ],
      },
      {
        'featureType': 'poi.school',
        'elementType': 'labels.icon',
        'stylers': [
          {
            'color': '#ab8362',
          },
        ],
      },
      {
        'featureType': 'road',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#f5f1e6',
          },
        ],
      },
      {
        'featureType': 'road.arterial',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#fdfcf8',
          },
        ],
      },
      {
        'featureType': 'road.highway',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#b0b43f',
          },
        ],
      },
      {
        'featureType': 'road.highway',
        'elementType': 'geometry.stroke',
        'stylers': [
          {
            'color': '#b0b43f',
          },
        ],
      },
      {
        'featureType': 'road.highway.controlled_access',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#b0b43f',
          },
        ],
      },
      {
        'featureType': 'road.local',
        'elementType': 'geometry.stroke',
        'stylers': [
          {
            'color': '#f3cfa4',
          },
          {
            'weight': 0.5,
          },
        ],
      },
      {
        'featureType': 'road.local',
        'elementType': 'labels.text.fill',
        'stylers': [
          {
            'color': '#806b63',
          },
        ],
      },
      {
        'featureType': 'transit.line',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#dfd2ae',
          },
        ],
      },
      {
        'featureType': 'transit.line',
        'elementType': 'labels.text.fill',
        'stylers': [
          {
            'color': '#8f7d77',
          },
        ],
      },
      {
        'featureType': 'transit.line',
        'elementType': 'labels.text.stroke',
        'stylers': [
          {
            'color': '#ebe3cd',
          },
        ],
      },
      {
        'featureType': 'transit.station',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#dfd2ae',
          },
        ],
      },
      {
        'featureType': 'water',
        'elementType': 'geometry.fill',
        'stylers': [
          {
            'color': '#d6cdbf',
          },
        ],
      },
      {
        'featureType': 'water',
        'elementType': 'labels.text.fill',
        'stylers': [
          {
            'color': '#92998d',
          },
        ],
      },
    ],
  };

  // eslint-disable-next-line no-undef 
  var map = new google.maps.Map(document.getElementById('map'), options);

    // eslint-disable-next-line no-undef
    marker = new google.maps.Marker({
      position: center,
      map: map,
    });

    console.log(document.getElementById('map2'))

  if(null != document.getElementById('map2')) {

    console.log('in');
    // eslint-disable-next-line no-undef 
    var map2 = new google.maps.Map(document.getElementById('map2'), options);

    // eslint-disable-next-line no-undef
    marker2 = new google.maps.Marker({
      position: center,
      map: map2,
    });
  }
  






}
window.initMap = initMap;



// WEBPACK FOOTER //
// ./scripts/main.js